import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import ReduxPromise from "redux-promise";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import rootReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["clients", "transactions"],
};

const transactionsPersistConfig = {
  key: "transactions",
  storage,
  whitelist: ["list"],
};

const rootReducers = combineReducers({
  ...rootReducer,
  transactions: persistReducer(
    transactionsPersistConfig,
    rootReducer.transactions
  ),
});

const persistedReducer = persistReducer(persistConfig, rootReducers);

export default () => {
  let store = configureStore({
    reducer: persistedReducer,
    middleware: [ReduxPromise],
  });

  let persistor = persistStore(store);
  return { store, persistor };
};
